import t from "../helpers/t";
import React from "react";

const FileUpload = (props:any) =>
{
    const {onChange, file, setFile, showInput, extraClasses, addButtonDirection, addButtonText,showPreviewLabel} = props
    let showInputs = true, showPreviewLabels = true, extraTopClasses = '', addButtonDirections = 'up', addButtonTexts = "+ "+t('add_${a}',{a:t('file')});
    if(typeof showInput !== 'undefined'){
        showInputs = showInput;
    }
    if(typeof showPreviewLabel !== 'undefined'){
        showPreviewLabels = showPreviewLabel;
    }
    if(typeof extraClasses !== 'undefined'){
        extraTopClasses = extraClasses;
    }
    if(typeof addButtonDirection !== 'undefined'){
        addButtonDirections = addButtonDirection;
    }
    if(typeof addButtonText !== 'undefined') {
        addButtonTexts = addButtonText;
    }

    const uploadFile = (fi:any) => {
        console.log(fi);
        setFile(fi);
        onChange(fi);
    }

    const onUploadFile = (e:any) => {
        const files = e.target.files[0];

            if (files) {
                let reader = new FileReader();
                reader.readAsText(files, "UTF-8");
                reader.onload = function (evt: ProgressEvent<FileReader>) {
                    uploadFile(evt?.target?.result);
                }
                reader.onerror = function (evt) {
                    alert("error reading file");
                }

        }
    }
    const reset = (e:any) => {
        e.target.value = "";
        setFile("");
        onChange(e);
    }
    const disabled = typeof props.disabled !== 'undefined'?props.disabled:'';
    return (
        <>
            <div className="inb-form-group-column medium-6 small-12 lang">
                {addButtonDirections === 'up' && <><label
                    htmlFor="upload-file-input"
                    className="inb-form__controlLabel"
                    style={{fontSize:'.85rem',fontWeight:'normal', padding:"0 1rem"}}>
                    {disabled === '' &&<><a>
                        {/* Left the href="#" out by purpose: fileInput wouldn't get called */}
                        <i className="fi fi-page-add product-icon"></i>
                        {addButtonTexts}
                    </a></>}
                </label>
                <input
                    id="upload-file-input"
                    className="form-control"
                    name="upload-file-input"
                    disabled={disabled}
                    type="file"
                    style={{position: 'fixed', top: '-100em'}}
                    onChange={onUploadFile}
                /></>}
                {showInputs &&
                    <div style={{display: "flex", width: "100%"}}>
                        <span style={{float: "left", padding: "5px 0 5px 1rem"}}>{t('link', null, 'capital')}:</span>
                        <input type="text" className="form-control" name="_image" onChange={onChange} disabled={disabled}
                               style={{float: "left", width: "90%"}} value={file}/>
                        {disabled === "" && <> <a href="#" id={"image_input__reset"}
                           className={"image_input__reset " + (file !== '' ? '' : "hide")} onClick={reset}>
                            x
                        </a></>}
                    </div>
                }
            </div>

            {addButtonDirections === 'down' &&  <><label
                htmlFor="upload-file-input"
                className="inb-form__controlLabel"
                style={{fontSize:'.85rem',fontWeight:'normal', padding:"0 1rem"}}>
                {disabled === "" && <><a>
                    {/* Left the href="#" out by purpose: fileInput wouldn't get called */}
                    <i className="fi fi-page-add product-icon"></i>
                    {addButtonTexts}
                </a></>}
            </label>
                <input
                    id="upload-file-input"
                    className="form-control"
                    name="upload-file-input"
                    type="file"
                    disabled={disabled}
                    style={{position: 'fixed', top: '-100em'}}
                    onChange={onUploadFile}
                /></>}
        </>
    )
}
export default FileUpload;